export const CustomerTypeEnum = Object.freeze({
    individual: "Individual",
    enterprise: "Enterprise",
    government: "Government"
})